import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback, useMemo, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPView3DButton from 'components/consumer/PDP/PDPView3DButton';
import RatioContainer from 'components/consumer/RatioContainer';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import PDPFullScreenGallery from 'components/consumer/PDP/PDPFullScreenGallery';
import PDPMobileGalleryZoomIcon from 'components/consumer/PDP/PDPMobileGalleryZoomIcon';
import PDPFavoriteButton from 'components/consumer/PDPFavoriteButton';
import CSSScrollSnapCarousel from 'components/consumer/CSSScrollSnapCarousel';
import scrollIntoViewUtil from 'commons/scrollIntoViewUtil';
import { markLuxPageNavigationEnd } from 'commons/lux';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import PDPProductIntroVideo from '../PDPDesktopHeroGallery/PDPProductIntroVideo';
import { getMainImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';
import PDPShownIn from '../PDPShownIn';
const CarouselSelectedIndexContext = React.createContext(0);
const PDPCarouselIntroVideoSlide = t0 => {
  const $ = _c(2);
  const {
    slideIndex,
    videoId
  } = t0;
  const selectedCarouselIndex = useContext(CarouselSelectedIndexContext);
  if (slideIndex !== selectedCarouselIndex) {
    return null;
  }
  let t1;
  if ($[0] !== videoId) {
    t1 = <PDPProductIntroVideo videoId={videoId} />;
    $[0] = videoId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PDPCarouselIntroVideoSlide.propTypes = {
  slideIndex: PropTypes.number.isRequired,
  videoId: PropTypes.string.isRequired
};

// Return items that have a unique id or videoId field
const getUniqueCarouselItems = items => {
  const uniqueItems = [];
  const seenIds = new Set();
  items.forEach(item => {
    const id = item.id || item.videoId;
    if (id && !seenIds.has(id)) {
      seenIds.add(id);
      uniqueItems.push(item);
    }
  });
  return uniqueItems;
};
const DEFAULT_PHOTOS = [];
const PDPMobileCarousel = t0 => {
  const $ = _c(93);
  const {
    displayShownIn: t1,
    enableCrops: t2,
    headerLeft,
    isConfigFlipped: t3,
    isEditOrder: t4,
    isHero: t5,
    maxPhotos: t6,
    onAfterSlide,
    photos: t7,
    productName,
    rightButtons,
    showARIcon: t8,
    showDecideLaterOverlay: t9,
    showFavoriteButton: t10,
    videoId,
    zoomOnClick: t11
  } = t0;
  const displayShownIn = t1 === undefined ? false : t1;
  const enableCrops = t2 === undefined ? true : t2;
  const isConfigFlipped = t3 === undefined ? false : t3;
  const isEditOrder = t4 === undefined ? false : t4;
  const isHero = t5 === undefined ? false : t5;
  const maxPhotos = t6 === undefined ? 16 : t6;
  const photos = t7 === undefined ? DEFAULT_PHOTOS : t7;
  const showARIcon = t8 === undefined ? false : t8;
  const showDecideLaterOverlay = t9 === undefined ? false : t9;
  const showFavoriteButton = t10 === undefined ? false : t10;
  const zoomOnClick = t11 === undefined ? true : t11;
  const validPhotos = useRemoveBrokenImageUrls(photos);
  const isConfigurationGallery = validPhotos?.[0]?.type === "configuration" || validPhotos?.[0]?.type === "cylindo";
  const [isFullScreenGalleryOpen, setIsFullScreenGalleryOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  let t12;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {};
    $[0] = t12;
  } else {
    t12 = $[0];
  }
  const [brokenImages, setBrokenImages] = useState(t12);
  const hasMoreThanMaxPhotos = validPhotos.length > maxPhotos;
  let t13;
  if ($[1] !== hasMoreThanMaxPhotos || $[2] !== maxPhotos || $[3] !== validPhotos || $[4] !== videoId) {
    const trimmedPhotos = hasMoreThanMaxPhotos ? validPhotos.slice(0, maxPhotos) : validPhotos;
    t13 = videoId && trimmedPhotos.length ? [trimmedPhotos[0], {
      videoId
    }, ...trimmedPhotos.slice(1)] : trimmedPhotos;
    $[1] = hasMoreThanMaxPhotos;
    $[2] = maxPhotos;
    $[3] = validPhotos;
    $[4] = videoId;
    $[5] = t13;
  } else {
    t13 = $[5];
  }
  const photosAndVideo = t13;
  const carouselPhotos = photosAndVideo;
  const standardRatio = isConfigurationGallery ? 0.6666666666666666 : 0.5;
  let t14;
  if ($[6] !== displayShownIn) {
    t14 = () => {
      if (!displayShownIn) {
        return;
      }
      scrollIntoViewUtil("[data-xc=\"PDPMobileConfigurationPhotoGalleryUI\"]", 0);
    };
    $[6] = displayShownIn;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  const scrollDownToCustomizer = t14;
  let t15;
  if ($[8] !== onAfterSlide) {
    t15 = slideIndex => {
      setSelectedCarouselIndex(slideIndex);
      onAfterSlide?.(slideIndex);
    };
    $[8] = onAfterSlide;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  const handleSlideChange = t15;
  let t16;
  if ($[10] !== carouselPhotos) {
    t16 = getUniqueCarouselItems(carouselPhotos);
    $[10] = carouselPhotos;
    $[11] = t16;
  } else {
    t16 = $[11];
  }
  const uniqueCarouselPhotos = t16;
  let t17;
  if ($[12] !== uniqueCarouselPhotos) {
    t17 = uniqueCarouselPhotos.findIndex(_temp);
    $[12] = uniqueCarouselPhotos;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  const videoSlideIndex = t17;
  const isVideoSlideSelected = videoSlideIndex !== -1 && selectedCarouselIndex === videoSlideIndex;
  let t18;
  if ($[14] !== brokenImages || $[15] !== displayShownIn || $[16] !== enableCrops || $[17] !== hasMoreThanMaxPhotos || $[18] !== isConfigFlipped || $[19] !== isConfigurationGallery || $[20] !== isEditOrder || $[21] !== isHero || $[22] !== productName || $[23] !== scrollDownToCustomizer || $[24] !== showDecideLaterOverlay || $[25] !== standardRatio || $[26] !== uniqueCarouselPhotos || $[27] !== validPhotos.length || $[28] !== zoomOnClick) {
    let t19;
    if ($[30] !== brokenImages || $[31] !== displayShownIn || $[32] !== enableCrops || $[33] !== hasMoreThanMaxPhotos || $[34] !== isConfigFlipped || $[35] !== isConfigurationGallery || $[36] !== isEditOrder || $[37] !== isHero || $[38] !== productName || $[39] !== scrollDownToCustomizer || $[40] !== showDecideLaterOverlay || $[41] !== standardRatio || $[42] !== uniqueCarouselPhotos.length || $[43] !== validPhotos.length || $[44] !== zoomOnClick) {
      t19 = (t20, index) => {
        const {
          src,
          id,
          type,
          cropData,
          videoId: videoId_0,
          optionId,
          upholsteryName,
          valueId
        } = t20;
        const slideKey = videoId_0 ? `video-${videoId_0}` : `${id || src || index}`;
        return {
          key: slideKey,
          slide: <RatioContainer className={classNames({
            "pt-8 px-6 pb-11": isConfigurationGallery && !enableCrops,
            "scale-x-[-1]": isConfigurationGallery && isConfigFlipped,
            "flex justify-center": brokenImages[src]
          })} ratio={enableCrops ? 1 : standardRatio}>{videoId_0 ? <PDPCarouselIntroVideoSlide slideIndex={index} videoId={videoId_0} /> : <>{displayShownIn ? <PDPShownIn isEditOrder={isEditOrder} optionId={optionId} upholsteryName={upholsteryName} valueId={valueId} layout="roundSwatchLabel" onSelection={scrollDownToCustomizer} productName={productName} showInactiveUpholstery={true} /> : null}<JBProductImage className="h-full object-contain w-full" {...getMainImageImgixPropsForPhoto({
                src,
                type,
                cropData
              }, enableCrops)} lazy={index !== 0} priority={index === 0 && isHero} sizes="100vw" onClick={zoomOnClick ? showDecideLaterOverlay ? _temp2 : () => {
                setSelectedCarouselIndex(index);
                setIsFullScreenGalleryOpen(true);
              } : undefined} forPage="pdp" onLoad={isFail => {
                if (index === 0 && isHero) {
                  markLuxPageNavigationEnd();
                }
                if (!isFail) {
                  return;
                }
                setBrokenImages({
                  ...brokenImages,
                  [src]: true
                });
              }} /></>}{hasMoreThanMaxPhotos && index === uniqueCarouselPhotos.length - 1 && <div className="items-center bottom-0 flex justify-center left-0 pointer-events-none absolute right-0 top-0"><div className="text-lg font-bold bg-brand-lightest text-brand-dark px-4 py-3">Explore{" "}{validPhotos.length - uniqueCarouselPhotos.length}+ more photos</div></div>}</RatioContainer>
        };
      };
      $[30] = brokenImages;
      $[31] = displayShownIn;
      $[32] = enableCrops;
      $[33] = hasMoreThanMaxPhotos;
      $[34] = isConfigFlipped;
      $[35] = isConfigurationGallery;
      $[36] = isEditOrder;
      $[37] = isHero;
      $[38] = productName;
      $[39] = scrollDownToCustomizer;
      $[40] = showDecideLaterOverlay;
      $[41] = standardRatio;
      $[42] = uniqueCarouselPhotos.length;
      $[43] = validPhotos.length;
      $[44] = zoomOnClick;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    t18 = uniqueCarouselPhotos.map(t19).filter(Boolean);
    $[14] = brokenImages;
    $[15] = displayShownIn;
    $[16] = enableCrops;
    $[17] = hasMoreThanMaxPhotos;
    $[18] = isConfigFlipped;
    $[19] = isConfigurationGallery;
    $[20] = isEditOrder;
    $[21] = isHero;
    $[22] = productName;
    $[23] = scrollDownToCustomizer;
    $[24] = showDecideLaterOverlay;
    $[25] = standardRatio;
    $[26] = uniqueCarouselPhotos;
    $[27] = validPhotos.length;
    $[28] = zoomOnClick;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  const slides = t18;
  let t19;
  if ($[46] !== handleSlideChange || $[47] !== slides) {
    t19 = <CSSScrollSnapCarousel height="medium" onSlideChange={handleSlideChange} slides={slides} />;
    $[46] = handleSlideChange;
    $[47] = slides;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== selectedCarouselIndex || $[50] !== t19) {
    t20 = <CarouselSelectedIndexContext.Provider value={selectedCarouselIndex}>{t19}</CarouselSelectedIndexContext.Provider>;
    $[49] = selectedCarouselIndex;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  const t21 = !displayShownIn;
  const t22 = !showDecideLaterOverlay;
  let t23;
  if ($[52] !== displayShownIn || $[53] !== showDecideLaterOverlay || $[54] !== t21 || $[55] !== t22) {
    t23 = classNames("absolute right-4 top-4 z-[1]", {
      "justify-between left-4": t21,
      "justify-end": displayShownIn,
      flex: t22,
      "!hidden": showDecideLaterOverlay
    });
    $[52] = displayShownIn;
    $[53] = showDecideLaterOverlay;
    $[54] = t21;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== displayShownIn || $[58] !== headerLeft) {
    t24 = !displayShownIn ? <div className="pointer-events-none">{!!headerLeft && headerLeft}</div> : null;
    $[57] = displayShownIn;
    $[58] = headerLeft;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== showARIcon) {
    t25 = showARIcon && <PDPView3DButton />;
    $[60] = showARIcon;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== isConfigurationGallery || $[63] !== isVideoSlideSelected || $[64] !== zoomOnClick) {
    t26 = !!zoomOnClick && !isVideoSlideSelected && <PDPMobileGalleryZoomIcon inverted={isConfigurationGallery} onClick={() => {
      setIsFullScreenGalleryOpen(true);
    }} />;
    $[62] = isConfigurationGallery;
    $[63] = isVideoSlideSelected;
    $[64] = zoomOnClick;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== showFavoriteButton) {
    t27 = showFavoriteButton && <PDPFavoriteButton size="sm" className="ml-0" />;
    $[66] = showFavoriteButton;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  const t28 = !!rightButtons && rightButtons;
  let t29;
  if ($[68] !== t27 || $[69] !== t28) {
    t29 = <div className="flex flex-col gap-2">{t27}{t28}</div>;
    $[68] = t27;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t25 || $[72] !== t26 || $[73] !== t29) {
    t30 = <div className="flex [&_>_*_+_*]:ml-2.5">{t25}{t26}{t29}</div>;
    $[71] = t25;
    $[72] = t26;
    $[73] = t29;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== t23 || $[76] !== t24 || $[77] !== t30) {
    t31 = <div className={t23}>{t24}{t30}</div>;
    $[75] = t23;
    $[76] = t24;
    $[77] = t30;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t20 || $[80] !== t31) {
    t32 = <div className="relative">{t20}{t31}</div>;
    $[79] = t20;
    $[80] = t31;
    $[81] = t32;
  } else {
    t32 = $[81];
  }
  let t33;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = () => {
      setIsFullScreenGalleryOpen(false);
    };
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== displayShownIn || $[84] !== isEditOrder || $[85] !== isFullScreenGalleryOpen || $[86] !== productName || $[87] !== selectedCarouselIndex || $[88] !== validPhotos) {
    t34 = <BrowserOnly><PDPFullScreenGallery isEditOrder={isEditOrder} isOpen={isFullScreenGalleryOpen} photos={validPhotos} initialSelectedPhotoIndex={selectedCarouselIndex} onClose={t33} productName={productName} displayShownIn={displayShownIn} /></BrowserOnly>;
    $[83] = displayShownIn;
    $[84] = isEditOrder;
    $[85] = isFullScreenGalleryOpen;
    $[86] = productName;
    $[87] = selectedCarouselIndex;
    $[88] = validPhotos;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== t32 || $[91] !== t34) {
    t35 = <>{t32}{t34}</>;
    $[90] = t32;
    $[91] = t34;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  return t35;
};
PDPMobileCarousel.propTypes = {
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  headerLeft: PropTypes.node,
  isConfigFlipped: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isHero: PropTypes.bool,
  maxPhotos: PropTypes.number,
  onAfterSlide: PropTypes.func,
  onDimensionsIconClick: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    src: PropTypes.string,
    type: PropTypes.string
  })),
  productName: PropTypes.string,
  rightButtons: PropTypes.node,
  showARIcon: PropTypes.bool,
  showDecideLaterOverlay: PropTypes.bool,
  showFavoriteButton: PropTypes.bool,
  videoId: PropTypes.string,
  zoomOnClick: PropTypes.bool
};
export default PDPMobileCarousel;
function _temp(item) {
  return item.videoId;
}
function _temp2() {}